import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: JSON.parse(localStorage.getItem('user')) || null,
    token: localStorage.getItem('token') || '',
    activities: [
      {
        id: 1,
        title: '校园歌唱比赛',
        date: '2023-06-15',
        location: '大学礼堂',
        description: '一年一度的校园歌唱比赛，欢迎所有学生参加！',
        organizer: '学生会文艺部',
        status: '招募中',
        image: 'https://picsum.photos/id/1/300/200',
        participants: [],
        maxParticipants: 30,
        requirements: '校内学生均可报名参加',
        createdBy: 1,
        reviews: []
      },
      {
        id: 2,
        title: '创新创业讲座',
        date: '2023-06-20',
        location: '学术报告厅',
        description: '邀请知名企业家分享创业经验，解答学生疑问',
        organizer: '创新创业学院',
        status: '招募中',
        image: 'https://picsum.photos/id/2/300/200',
        participants: [],
        maxParticipants: 100,
        requirements: '对创业有兴趣的学生',
        createdBy: 1,
        reviews: []
      },
      {
        id: 3,
        title: '校园马拉松',
        date: '2023-07-01',
        location: '校园跑道',
        description: '5公里校园马拉松，增强体魄，挑战自我',
        organizer: '体育部',
        status: '招募中',
        image: 'https://picsum.photos/id/3/300/200',
        participants: [],
        maxParticipants: 200,
        requirements: '身体健康，能够完成5公里跑步',
        createdBy: 2,
        reviews: []
      }
    ],
    users: [
      {
        id: 1,
        username: 'admin',
        password: '123456',
        role: 'admin',
        name: '系统管理员',
        avatar: 'https://picsum.photos/id/1001/100/100'
      },
      {
        id: 2,
        username: 'organizer',
        password: '123456',
        role: 'organizer',
        name: '活动组织者',
        avatar: 'https://picsum.photos/id/1002/100/100'
      },
      {
        id: 3,
        username: 'student',
        password: '123456',
        role: 'user',
        name: '普通学生',
        avatar: 'https://picsum.photos/id/1003/100/100'
      }
    ]
  },
  mutations: {
    setUser(state, user) {
      state.user = user
      localStorage.setItem('user', JSON.stringify(user))
    },
    setToken(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    logout(state) {
      state.user = null
      state.token = ''
      localStorage.removeItem('user')
      localStorage.removeItem('token')
    },
    addActivity(state, activity) {
      activity.id = state.activities.length + 1
      activity.participants = []
      activity.reviews = []
      activity.createdBy = state.user.id
      state.activities.push(activity)
    },
    updateActivity(state, updatedActivity) {
      const index = state.activities.findIndex(a => a.id === updatedActivity.id)
      if (index !== -1) {
        Vue.set(state.activities, index, {
          ...state.activities[index],
          ...updatedActivity
        })
      }
    },
    deleteActivity(state, activityId) {
      state.activities = state.activities.filter(a => a.id !== activityId)
    },
    registerActivity(state, { activityId, userId }) {
      const activity = state.activities.find(a => a.id === activityId)
      if (activity && !activity.participants.includes(userId)) {
        activity.participants.push(userId)
      }
    },
    addReview(state, { activityId, review }) {
      const activity = state.activities.find(a => a.id === activityId)
      if (activity) {
        if (!review.id) {
          review.id = activity.reviews.length + 1
        }
        activity.reviews.push(review)
      }
    }
  },
  actions: {
    login({ commit, state }, { username, password }) {
      return new Promise((resolve, reject) => {
        // 模拟登录请求
        const user = state.users.find(u => u.username === username && u.password === password)
        if (user) {
          const token = 'mock_token_' + Math.random().toString(36).substring(2)
          commit('setUser', { ...user, password: undefined })
          commit('setToken', token)
          resolve(user)
        } else {
          reject(new Error('用户名或密码错误'))
        }
      })
    },
    register({ commit, state }, userInfo) {
      return new Promise((resolve) => {
        // 模拟注册
        const newUser = {
          id: state.users.length + 1,
          username: userInfo.username,
          password: userInfo.password,
          role: 'user',
          name: userInfo.name || userInfo.username,
          avatar: 'https://picsum.photos/id/1004/100/100'
        }
        state.users.push(newUser)
        
        const token = 'mock_token_' + Math.random().toString(36).substring(2)
        commit('setUser', { ...newUser, password: undefined })
        commit('setToken', token)
        resolve(newUser)
      })
    }
  },
  getters: {
    isLoggedIn: state => !!state.token,
    currentUser: state => state.user,
    isAdmin: state => state.user && state.user.role === 'admin',
    isOrganizer: state => state.user && (state.user.role === 'organizer' || state.user.role === 'admin'),
    getActivityById: state => id => {
      return state.activities.find(activity => activity.id === parseInt(id))
    },
    getMyActivities: state => {
      if (!state.user) return []
      return state.activities.filter(activity => activity.createdBy === state.user.id)
    },
    getRegisteredActivities: state => {
      if (!state.user) return []
      return state.activities.filter(activity => 
        activity.participants.includes(state.user.id)
      )
    }
  }
}) 